import { createActions } from 'reduxsauce';

export const Pages = [
  'VisaDetails',
  'PersonalDetails',
  'TravelDetails',
  'ContactDetails',
];

const { Types, Creators } = createActions({
  getApplicationsRequest: null,
  getApplicationsSuccess: ['applications'],
  getApplicationsFailure: ['error'],
  getApplicationRequest: ['uuid'],
  getApplicationSuccess: ['application'],
  getApplicationFailure: ['error'],
  getUsers: null,
  getUsersSuccess: ['users'],
  getUsersFailure: ['error'],
  setApplication: ['application'],
  goToPreviousPage: null,
  validateRequest: ['history'],
  validateSuccess: ['errors'],
  saveRequest: ['history'],
  saveSuccess: ['data'],
  saveFailure: ['error'],
  submitRequest: ['uuid', 'history'],
  submitSuccess: ['data'],
  submitFailure: ['error'],
  formValueChanged: ['id', 'value'],
  sendMessageRequest: ['message', 'file', 'documentTypeId'],
  sendMessageSuccess: ['message'],
  sendMessageFailure: ['error'],
  sendMessageToApplicantRequest: ['message', 'history'],
  sendMessageToApplicantSuccess: ['message'],
  sendMessageToApplicantFailure: ['error'],
  clearMessageSent: null,
  uploadRequest: ['file', 'documentTypeId', 'docUuid'],
  uploadSuccess: ['document'],
  uploadFailure: ['error'],
  deleteDocumentRequest: ['documentTypeId', 'docUuid'],
  deleteDocumentSuccess: ['document'],
  deleteDocumentFailure: ['error'],
  clearCurrentApplication: null,
  setFilters: ['filters'],
  setPage: ['page'],
  setPerPage: ['perPage'],
  setTotal: ['total'],
  checkZeroPayment: ['applicationId'],
  successCheckZeroPayment: ['zeroPayment'],
  failureCheckZeroPayment: ['error'],
  downloadApplicationRequest: ['applicationId'],
  downloadApplicationSuccess: null,
  downloadApplicationFailure: ['error'],
});

export const ApplicationTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/ApplicationActions.js